import { IToggleFieldVisibility } from '../../../../actions/bookingCalendar/reservationModal/fieldVisibility'
import { IBookingCalendarStore } from '../../index'

export default function(
  state: IBookingCalendarStore,
  action: IToggleFieldVisibility,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      fieldVisibility: {
        ...state.reservationModal.fieldVisibility,
        [action.fieldName]: action.value,
      },
    },
  }
}
